






































































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import BaseMultiSelect from '@/jbi-shared/vue-components/BaseMultiSelect.vue';
import DropdownMultiselect from '@/components/DropdownMultiselect.vue';
import { CourseTypeOption } from '@/store/modules/jtms/course/course.types';

@Component({
  components: {
    BaseMultiSelect,
    ValidationProvider,
    DropdownMultiselect
  }
})
export default class CourseNameAndTypeForm extends Vue {
  @PropSync('courseName', { type: String }) syncedCourseName!: string;
  @PropSync('courseType', { type: Object }) syncedTypes!: CourseTypeOption;
  @Prop(Array) courseTypeOptions!: CourseTypeOption[];
  courseTypes: CourseTypeOption[] = [];

  mounted() {
    if (this.courseTypeOptions) {
      this.courseTypes = this.courseTypeOptions;
    }
  }
}
